<ch-breadcrumb [parts]="breadcrumb" (goTo)="null"></ch-breadcrumb>

<div class="card">
  <div class="card-header">
    Subscription Plans
    <a id='subscriptionPlansListingNew' [routerLink]="['/admin/subscription-plans/add']" class="btn btn-default pull-right">New</a>
    <button class="btn btn-default pull-right" (click)="toggleShowArchived()">
      {{ showArchived ? 'Hide Archived' : 'Show Archived' }}
    </button>
  </div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">No items found.</p>

      <table class="table table-hover" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th>
              <span class="col-name">Name</span>
            </th>
            <th>
              <span class="col-name">Amount</span>
            </th>
            <th>
              <span class="col-name">Interval Unit</span>
            </th>
            <th>
              <span class="col-name">Interval Value</span>
            </th>
            <th>
              <span class="col-name">Trial Period</span>
            </th>
            <th>
              <span class="col-name">Type</span>
            </th>
            <th>
              <span class="col-name">Default</span>
            </th>
            <th>
              <span class="col-name">RAF Default</span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index" [class.warning]="item.archivedAt">
            <td>
              <span>{{ item.name }}</span>
            </td>
            <td>
              <span>{{ item.amount }}{{ item.currency }}</span>
            </td>
            <td>
              <span>{{ item.intervalUnit }}</span>
            </td>
            <td>
              <span>{{ item.intervalValue }}</span>
            </td>
            <td>
              <span>{{ item.trialPeriodDays }}</span>
            </td>
            <td>
              <span>{{ item.type }}</span>
            </td>
            <td>
              <input type="checkbox" [checked]="item.isDefault" onclick="return false;" />
            </td>
            <td>
              <input type="checkbox" [checked]="item.isRafDefault" onclick="return false;" />
            </td>
            <td class="col-md-1">
              <a class="btn btn-primary" [routerLink]="['/admin/subscription-plans/edit']" [queryParams]="{ id: item.id }">
                {{ item.archivedAt ? 'View' : 'Edit' }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div>
  <div class="page-bottom-container action-buttons">
    <ch-pagination
      *ngIf="!loading"
      [totalItems]="totalItems"
      [pageNumber]="pageParams.pageNumber"
      [pageSize]="pageParams.pageSize"
      (pageChanged)="onPageChanged($event)"
    ></ch-pagination>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/subscription-plans/subscription-plans-listing/subscription-plans-listing.component.html